import { string } from 'prop-types'

const ProductShortDescription = ({ descriptionShort }) =>
  descriptionShort ? (
    <div className="u-margin--bottom o-ProductShortDescription">
      {descriptionShort}
    </div>
  ) : null

ProductShortDescription.propTypes = {
  descriptionShort: string,
}

ProductShortDescription.defaultProps = {
  descriptionShort: null,
}

export default ProductShortDescription
